<div class="page-layout simple" particleHelpNotes helpNoteId="dashboard"> <!-- fusePerfectScrollbar -->

  <!-- HEADER -->
  <div *ngIf="childUrlChange!==undefined" class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <particle-filter-summary [filterKey]="filterKey" [inputQueryParams]="filterQueryParams" class="full-grow-no-shrink-no-basis " >

    </particle-filter-summary>

    <div class="grid-toolbar-buttons-group-container m-l-20 flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="resetReport()"
                  particleAnalytics
                  analyticsCategory="analytics"
                  analyticsAction="reset-Report"
                  [disabled]="!this.dashboardHitmap.dataLoaded && !(this.dashboardHitmap.failureResponse$ | async)"
          >Reset Report
          </button>
          <button mat-button class="orbitax-flat-button m-l-20" (click)="refreashReportService()"
                  particleAnalytics
                  analyticsCategory="dashboard-content"
                  analyticsAction="refresh-report"
                  [disabled]="!this.dashboardHitmap.dataLoaded && !(this.dashboardHitmap.failureResponse$ | async)"
          >Refresh Report
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- / HEADER -->

  <mat-sidenav-container class="particle-page-content-container">
    <!-- CONTENT -->
    <div class="content">

      <!--<particle-filter-tab [filterKey]="filterKey">

      </particle-filter-tab>-->
      <particle-dashboard-hitmap></particle-dashboard-hitmap>

    </div>
    <!-- / CONTENT -->

  </mat-sidenav-container>

</div>
